// import { StrictMode } from "react";
import { createRoot } from 'react-dom/client';
import './index.css';
import './core/i18n';
import Providers from './providers/index.tsx';

import * as Sentry from '@sentry/react';
import { registerSW } from 'virtual:pwa-register';
import { isTauri } from './lib/offline/isTauri';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  enabled: !import.meta.env.DEV,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  environment: import.meta.env.VITE_STAGE as string,
});

createRoot(document.getElementById('root')!).render(
  // <StrictMode>
  <Providers />,
  // </StrictMode>
);

// Service worker is WEB-PWA-ONLY. The Tauri desktop app serves its shell
// natively and uses the `offlineres://` custom protocol for offline resources —
// it doesn't need a SW, and service workers are unreliable in Tauri's WKWebView
// (a flaky SW can wedge the app-shell load on relaunch). So never register it
// inside Tauri.
if (isTauri()) {
  // Clean up any service worker registered by an older build — Tauri must not
  // use one, and a stale SW can keep wedging the app-shell load on relaunch.
  navigator.serviceWorker?.getRegistrations?.().then(
    (regs) => regs.forEach((r) => void r.unregister()),
    () => {},
  );
  // Tell Rust the resources origin so the offlineres:// proxy can resolve cache
  // misses (fetch the real CloudFront URL through the shared cookie jar).
  void import('@tauri-apps/api/core').then(({ invoke }) =>
    invoke('set_resources_base', { base: import.meta.env.VITE_RESOURCES_ENDPOINT }).catch(() => {}),
  );
} else if ('serviceWorker' in navigator) {
  registerSW({ immediate: true });
}
// Ask the OS not to evict offline data under disk pressure (web/OPFS only;
// native FS has no quota).
if (!isTauri() && navigator.storage?.persist) {
  void navigator.storage.persist();
}
